import React, { Component } from 'react';
import { FormControl, TextField, withStyles, Tooltip } from '@material-ui/core';
import styles from './CellSizeController.css';

class CellSizeController extends Component {

    constructor(props){
        super(props);
        this.state = {
            invalidNumber: false
        };
    }

    handleChange = event => {
        this.validateValue(event.target.value)
        this.props.changeCellSize(event.target.value);
    }
    
    validateValue = (value) => {
        this.setState({
            invalidNumber: !(value>=1 && value<=300)
        });
    }
    
    render() {
        
        const {classes, cellSize} = this.props;
        return (
            
            <div className={classes.CellSizeController}>
                <Tooltip
                    title="Please carefully select nucleus size to match the average diameter of nuclei on your images"
                >
                <FormControl noValidate>
                    <Tooltip
                        title="Invalid value for nucleus size. Only numbers between 1 and 300 pixels are accepted."
                        disableHoverListener={true}
                        classes={{ tooltip: classes.lightTooltip }}
                        open={this.state.invalidNumber}
                    >
                        <TextField
                            label="Nucleus size in pixels"
                            value={cellSize}
                            onChange={this.handleChange}
                            className={classes.cellSizeTextField}
                            variant="outlined"
                            type="number"
                            margin="dense"
                            error={this.state.invalidNumber}
                            // endAdornment={<InputAdornment position="end">pixel</InputAdornment>}
                        >
                        </TextField>
                    </Tooltip>
                </FormControl>
                </Tooltip>
            </div>
        );
    }
}

export default withStyles(styles, {withTheme: true})(CellSizeController);